import { PickPartial, RequireAtLeastOne } from '@avalenti89/typescript-utils';
import { ResponsiveObject, Settings } from 'react-slick';
import { IFormConfig } from '../IMessageFormConfigData';

export type ILinkAction = { url: string; target: 'new' | 'current' };
export type IBaseListAction = {
	link?: string | ILinkAction;
	postback?: any;
	message?: string;
	label: string;
	className?: string;
	color?: string;
};

export type IBaseListActions =
	| IBaseListAction
	| [IBaseListAction]
	| [IBaseListAction, IBaseListAction];

type IBaseItem = {
	title: string;
	description?: string;
	image: string;
};

export type IAccordionItem = IBaseItem & {
	form?: IFormConfig;
	text: string;
	actions: IBaseListActions;
};

export enum WidgetType {
	ACCORDION = 'accordion',
	CAROUSEL = 'carousel',
	FORM = 'form',
	HTML = 'html',
	IFRAME = 'iframe',
}

export type IMessageCommandAccordionParameters = {
	widget: WidgetType.ACCORDION;
	data: {
		items: IAccordionItem[];
	};
};

export type ICarouselItem = PickPartial<IBaseItem, 'title'> & {
	actions: IBaseListActions[];
};

export type ISliderBaseSettings = Pick<
	Settings,
	'slidesToScroll' | 'slidesToShow' | 'infinite' | 'autoplay'
>;
export type ISliderSettings = ISliderBaseSettings & {
	responsive?: Array<
		Omit<ResponsiveObject, 'settings'> & { settings: ISliderBaseSettings }
	>;
};

export enum CarouselVariant {
	RICH = 'rich',
	SIMPLE = 'simple',
}
export enum CarouselImageFormat {
	WIDE = 'wide',
	SQUARE = 'square',
}
export type ICarouselSettings = {
	variant?: CarouselVariant;
	image_format?: CarouselImageFormat;
	margins?: boolean;
	cover?: boolean;
};

export type IMessageCommandCarouselParameters = {
	widget: WidgetType.CAROUSEL;
	data: {
		items: ICarouselItem[];
		settings?: ISliderSettings & ICarouselSettings;
	};
};

export type IMessageCommandFormExtraParameters = {
	reusable?: boolean;
	fullscreen?: boolean;
	lock_input?: boolean;
	hide_when_disabled?: boolean;
};

export type IMessageCommandFormParameters = {
	widget: WidgetType.FORM;
	data: RequireAtLeastOne<
		IFormConfig<IMessageCommandFormExtraParameters>,
		'header'
	>;
};

export type IMessageCommandHtmlParameters = {
	widget: WidgetType.HTML;
	data: string;
};

export type IMessageCommandIframeParameters = {
	widget: WidgetType.IFRAME;
	data: {
		id: string;
	} & ({ url: string } | { html: string });
};

export type IMessageCommandWidgetParameters =
	| IMessageCommandAccordionParameters
	| IMessageCommandCarouselParameters
	| IMessageCommandFormParameters
	| IMessageCommandHtmlParameters
	| IMessageCommandIframeParameters;
